// @flow
import commandRegistrar from './command-registrar';

commandRegistrar();
